import { Injectable } from '@angular/core';
import { DatasourceTableQuery } from '@y42/datasource';
import { DateTimeService } from '@y42/date-time';
import { GitQuery } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { UiModelingTableJobQuery } from '../datasource-table-job';
import { UiModelingStoreQuery } from '../datasource/ui-modeling.store-query';
import { UiModelingTableStore } from './ui-modeling-table.store';

@Injectable({ providedIn: 'root' })
export class UiModelingTableQuery extends DatasourceTableQuery {
  constructor(
    protected readonly store: UiModelingTableStore,
    protected readonly parentQuery: UiModelingStoreQuery,
    protected readonly gitQuery: GitQuery,
    protected readonly modelingTableJobQuery: UiModelingTableJobQuery,
    protected readonly dateTimeService: DateTimeService,
  ) {
    super(store, parentQuery, gitQuery, modelingTableJobQuery, dateTimeService);
  }

  readonly featureType = Y42FeatureType.UiModel;
}
